import { render } from "./HeroAddEventModal.vue?vue&type=template&id=2b3bf863&scoped=true"
import script from "./HeroAddEventModal.vue?vue&type=script&lang=js"
export * from "./HeroAddEventModal.vue?vue&type=script&lang=js"

import "./HeroAddEventModal.vue?vue&type=style&index=0&id=2b3bf863&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3bf863"]])

export default __exports__